import { render, staticRenderFns } from "./MasterMainteTab.vue?vue&type=template&id=97aca8bc&scoped=true&"
import script from "./MasterMainteTab.vue?vue&type=script&lang=ts&"
export * from "./MasterMainteTab.vue?vue&type=script&lang=ts&"
import style0 from "./MasterMainteTab.vue?vue&type=style&index=0&id=97aca8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aca8bc",
  null
  
)

export default component.exports